namespace $.$$ {

	$mol_style_define( $shm_hitalama_taskmanager, {
		width: '100%',
		minHeight: '100%',
	} )

}
